/**
 * 患者管理機能で使用する定数定義
 */

// デバウンス遅延時間
export const SEARCH_DEBOUNCE_DELAY = 300 as const

// アクションステータス定数
export const ACTION_STATUS = {
  PENDING: 'pending',
  PLANNED: 'planned',
  IN_PROGRESS: 'in_progress',
  DECLINED: 'declined',
  DONE: 'done',
} as const

// アクションステータスラベル
export const ACTION_STATUS_LABELS = {
  pending: '保留中',
  planned: '計画済み',
  in_progress: '実施中',
  declined: '却下',
  done: '完了',
} as const

// アクショングループ定数
export const ACTION_GROUP = {
  ADJUSTMENT_SUPPORT: 'adjustment_support',
  HOME_CARE: 'home_care',
  OTHER: 'other',
} as const

// アクショングループラベル
export const ACTION_GROUP_LABELS = {
  adjustment_support: '調整支援',
  home_care: '在宅介入',
  other: 'その他',
} as const

// ページネーション設定
export const PAGINATION_LIMITS = [25, 50, 100, 200] as const
export const DEFAULT_PAGE_LIMIT = 50

// ソート可能フィールド
export const SORTABLE_FIELDS = {
  NAME_KANJI: 'name_kanji',
  NAME_KANA: 'name_kana',
  PATIENT_CODE: 'patient_code',
  LAST_VISIT_DATE: 'last_visit_date',
} as const

// デフォルトソート設定
export const DEFAULT_SORT_FIELD = SORTABLE_FIELDS.NAME_KANA
export const DEFAULT_SORT_ORDER = 'asc' as const

// legacy shell の record 詳細タブ index (= apps/legacy/pages/index.tsx + PatientActionProposal が参照).
// ε 段階で legacy 物理 rm 時に削除.
export const TAB_INDICES = {
  BASIC_RECORD: 0,
  TRANSCRIPTION: 1,
  PRESCRIPTION_INFO: 2,
  ACTION_PROPOSAL: 3,
  GUIDANCE_SCRIPT: 4,
  GUIDANCE_DETAIL: 5,
} as const
